import React, { Component } from "react";
import Header from "../../../Components/MainLayout/Header";
import { connect } from "react-redux";
import axios from "axios";
import Authorize from "../../../../global/Authorize";
import Loader from "../../../Components/MainLayout/Loader";
import MySnackbar from "../../../Components/MyComponents/MySnackbar";
import UploadedHomework from "./UploadedHomework";

const mapStateToProps = ({ dispatch, user }) => ({
  dispatch,
  user,
});

class UploadHomeWork extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: [],
      loading: false,
      checkedsection: [],
      classes: [],
      section: [],
      subjectdata: [],
      value: [],
      file: null,
      subject: "",
      homework_title: "",
      homework_date: "",
      description: "",
      submission_date: "",
      marks: 0,
      for_section: [],
      status: true,
      snackbar: false,
      currentTab: 1,

      date: `${new Date().getFullYear()}-${
        (new Date().getMonth() + 1 < 10 ? "0" : "") +
        (new Date().getMonth() + 1)
      }-${(new Date().getDate() < 10 ? "0" : "") + new Date().getDate()}`,
    };
  }

  componentDidMount() {
    this.fetchclasses({
      school_id: this.props.user.user.school.id,
      status: true,
    });
    this.fetchsection({
      school_id: this.props.user.user.school.id,
      status: true,
    });
    this.fetchsubject({
      school_id: this.props.user.user.school.id,
      status: true,
    });
  }

  fetchclasses = (params = {}) => {
    axios
      .get(`/api/class`, {
        params: { ...params },
        type: "json",
      })
      .then((res) => {
        this.setState({
          classes: res.data,
        });
      });
  };

  fetchsection = (params = {}) => {
    axios
      .get(`/api/section`, {
        params: { ...params },
        type: "json",
      })
      .then((res) => {
        this.setState({
          section: res.data,
        });
      });
  };

  fetchsubject = (params = {}) => {
    axios
      .get(`/api/subject`, {
        params: { ...params },
        type: "json",
      })
      .then((res) => {
        this.setState({
          subjectdata: res.data,
        });
      });
  };
  handleImageChange = (e) => {
    this.setState({
      image: e.target.files[0],
    });
  };

  handleChange = (e) => {
    this.setState({
      [e.target.id]: e.target.value,
    });
  };

  onChangesection = (e) => {
    this.setState({
      for_section: e,
    });
  };
  onChananeclass = (e) => {
    this.setState({
      for_class: e.target.value,
    });
  };
  onChangeSubject = (e) => {
    this.setState({
      subject: e.target.value,
    });
  };
  handleCheckbox1 = (event) => {
    var arr = this.state.checkedsection;
    if (this.state.checkedsection.includes(event.target.value)) {
    } else {
      arr.push(event.target.value);
    }
    this.setState({ checkedsection: arr });
  };

  handleSubmit = () => {
    this.setState({ loading: true });
    var submission_date = this.state.submission_date
      ? this.state.submission_date
      : this.state.date;
    let form_data = new FormData();
    for (var i = 0; i < this.state.checkedsection.length; i++) {
      form_data.append("for_section", this.state.checkedsection[i]);
    }
    form_data.append("for_class", this.state.for_class);
    form_data.append("subject", this.state.subject);
    form_data.append("homework_title", this.state.homework_title);
    form_data.append("homework_date", this.state.date);
    form_data.append("submission_date", submission_date);
    form_data.append("marks", this.state.marks);
    form_data.append("description", this.state.description);
    form_data.append("status", this.state.status);
    form_data.append("school", this.props.user.user.school.id);
    form_data.append("user", this.props.user.user.id);
    form_data.append("session", this.props.user.session.id);
    if (this.state.image) {
      form_data.append("file", this.state.image, this.state.image.name);
    }
    axios
      .post(`/api/studenthomework`, form_data, {
        headers: { "Content-Type": "multipart/form-data" },
      })
      .then((response) => {
        if (response.status === 201) {
          this.setState({
            loading: false,
            checkedsection: [],
            classes: [],
            section: [],
            subjectdata: [],
            value: [],
            file: null,
            subject: "",
            homework_title: "",
            homework_date: "",
            description: "",
            submission_date: "",
            marks: 0,
            for_section: [],
            snackbar: true,
          });

          window.location.reload();
          this.handleSnackbar();
        }
      })
      .catch((error) => {
        this.setState({ loading: false });
      });
  };
  handleSnackbar = () => {
    setTimeout(() => this.setState({ snackbar: false }), 2000);
  };

  render() {
    const { classes, section, subjectdata, for_class } = this.state;

    let unrestrictedRoles = ["IS_SUPERADMIN", "IS_PRINCIPAL", "IS_ACCOUNTANT"];

    let assignedClassSubject = JSON.parse(
      localStorage.getItem("assignedClassSubject")
    );

    let assignedClass = assignedClassSubject?.mapping_data?.map(
      (each) => each.assign_class_id
    );
    let assignedClassList = unrestrictedRoles?.includes(
      this.props.user.role.name
    )
      ? classes
      : classes?.filter((each) => assignedClass?.includes(each.id));

    const classvalue = assignedClassList?.map((item) => (
      <option value={item.id}> {item.class_name} </option>
    ));

    if (for_class && for_class !== " ") {
      var tempAssignedSubject = assignedClassSubject?.mapping_data?.filter(
        (each) => each.assign_class_id === JSON.parse(for_class)
      )[0]?.assign_subject;
      var assignedSubject =
        tempAssignedSubject?.length > 0 ? JSON.parse(tempAssignedSubject) : [];
    }
    const subjectvalue = (
      unrestrictedRoles?.includes(this.props.user.role.name)
        ? subjectdata
        : subjectdata?.filter((each) => assignedSubject?.includes(each.id))
    )?.map((item) => <option value={item.id}> {item.subject} </option>);
    const sectiondata = section?.map((item) => (
      <div className="input-group in-line align-items-center pb-2 col-3">
        <input
          type="checkbox"
          onChange={this.handleCheckbox1}
          name="section"
          color="primary"
          value={item.id}
        />
        <div className="th-12 th-cap pl-2">{item.section_name}</div>
      </div>
    ));

    return (
      <Authorize roles={["IS_TEACHER", "IS_PRINCIPAL"]} redirect to="/login">
        <Header to="/home" title="Homework" />
        {/* <div className="d-flex flex-row th-no-scroll pt-2">
          <div className="pl-3 pr-4 text-center th-cap th-14 py-2">
            <div className="th-primary">Upload Homework</div>
            <hr
              className="w-100 my-1 th-border"
              style={{ borderWidth: 5, borderRadius: 5 }}
            />
          </div>
        </div> */}{" "}
        <div className="shadow-sm mb-2 row ">
          <div
            className={
              this.state.currentTab === 1
                ? "col-6 text-center th-cap th-12 py-2 border-bottom th-border mx-auto"
                : "col-6 text-center th-cap th-12 py-2 mx-auto"
            }
            onClick={() => this.setState({ currentTab: 1 })}
          >
            <div
              className={
                this.state.currentTab === 1 ? "th-primary" : "th-black"
              }
            >
              Upload Homework
            </div>
          </div>
          <div
            className={
              this.state.currentTab === 2
                ? "col-6 text-center th-cap th-12 py-2 border-bottom th-border mx-auto"
                : "col-6 text-center th-cap th-12 py-2 mx-auto"
            }
            onClick={() => this.setState({ currentTab: 2 })}
          >
            <div
              className={
                this.state.currentTab === 2 ? "th-primary" : "th-black"
              }
            >
              Uploaded Homework
            </div>
          </div>
        </div>
        {this.state.currentTab === 1 ? (
          <div className="container my-3 col-12">
            <div>
              <div className="th-12">Select Class</div>
              <div className="input-group shadow-sm">
                <select
                  className="form-control th-input-primary"
                  onChange={this.onChananeclass}
                >
                  <option value=" ">None</option>
                  {classvalue}
                </select>
              </div>
              <div className="input-group  mt-3">{sectiondata}</div>
              <div className="th-12">Select Subject</div>
              <div className="input-group shadow-sm">
                <select
                  className="form-control th-input-primary"
                  onChange={this.onChangeSubject}
                >
                  <option value=" ">None</option>
                  {subjectvalue}
                </select>
              </div>
              <div className="th-12 mt-2">Homework Title</div>
              <div className="input-group shadow-sm">
                <input
                  className="form-control th-input-primary"
                  placeholder="Enter Homework title"
                  onChange={this.handleChange}
                  value={this.state.homework_title}
                  id="homework_title"
                />
              </div>
              <div className="th-12 mt-2">Submission Date</div>
              <div className="input-group shadow-sm">
                <input
                  type="date"
                  className="form-control th-input-primary"
                  placeholder="Submission Date"
                  id="submission_date"
                  data-date-format="DD-MM-YYYY"
                  value={
                    this.state.submission_date
                      ? this.state.submission_date
                      : this.state.date
                  }
                  onChange={this.handleChange}
                />
              </div>
              <div className="input-group shadow-sm mt-2">
                <textarea
                  className="form-control th-input-primary"
                  placeholder="Description"
                  style={{ minHeight: 100 }}
                  id="description"
                  value={this.state.description}
                  onChange={this.handleChange}
                />
              </div>
              <div className="th-12 mt-2">Marks</div>
              <div className="input-group shadow-sm">
                <input
                  type="number"
                  className="form-control th-input-primary w-100"
                  placeholder="Marks"
                  onChange={this.handleChange}
                  id="marks"
                  value={this.state.marks}
                />
              </div>
              <div className="input-group mt-2">
                <input
                  type="file"
                  className="form-control th-input-primary w-100"
                  placeholder="Marks"
                  onChange={this.handleImageChange}
                  id="image"
                  accept="image/png, image/jpeg,.xlsx,.xls,image/*,.doc, .docx,.ppt, .pptx,.txt,.pdf"
                />
              </div>
              <div>
                {this.state.loading ? (
                  <div className="my-2 pr-2">
                    <Loader />
                  </div>
                ) : null}
                <button
                  onClick={this.handleSubmit}
                  type="submit"
                  className="th-btn-primary px-4 py-2 mt-2"
                >
                  SUBMIT
                </button>
              </div>
            </div>
          </div>
        ) : null}
        {this.state.currentTab === 2 ? <UploadedHomework /> : null}
        {this.state.snackbar ? (
          <MySnackbar title="Homework Added Successfully" />
        ) : null}
      </Authorize>
    );
  }
}

export default connect(mapStateToProps)(UploadHomeWork);
